import { CanActivate } from '@angular/router';
import { Inject, Injectable } from '@angular/core';

import { IClaims, IOktaToken } from '../interfaces';
import { WINDOW } from '@app/lib/services/window.service';
import { SUPERUSER } from '@app/user/user.constants';

@Injectable()
export class SuperuserGuard implements CanActivate {

  constructor(
    @Inject(WINDOW)
    private readonly window: Window,
  ) {}

  canActivate(): boolean {
    const storageData: IOktaToken = JSON.parse(this.window.localStorage.getItem('okta-token-storage'));
    const accessTokenClaims: Partial<IClaims> = storageData.accessToken.claims;

    return accessTokenClaims?.app_role === SUPERUSER;
  }
}
